module.exports = __webpack_public_path__ + "img/jsonplaceholder.cb570c61.png";